/* global axios */
import ApiClient from './ApiClient';

class MediaLibraryAPI extends ApiClient {
  constructor() {
    super('media_library_items', { accountScoped: true });
  }

  search(params) {
    return axios.get(this.url, { params });
  }

  taxonomy(params = {}) {
    return axios.get(`${this.url}/taxonomy`, { params });
  }

  saveTaxonomy(kind, record) {
    const { id, ...body } = record;
    const url = `${this.url}/taxonomy/${kind}`;
    return id ? axios.patch(`${url}/${id}`, body) : axios.post(url, body);
  }

  deleteTaxonomy(kind, record) {
    const id = kind === 'tags' ? 'tag' : record.id;
    return axios.delete(`${this.url}/taxonomy/${kind}/${id}`, {
      data: { name: record.name },
    });
  }

  download(id) {
    return axios.get(`${this.url}/${id}/download`, { responseType: 'blob' });
  }

  downloadPublished(id) {
    return axios.get(`${this.url}/${id}/download`, {
      responseType: 'blob',
      params: { published_only: true },
    });
  }
}

export default new MediaLibraryAPI();
